// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Z2WPN","brand-logo":"Footer_brand-logo__S6Jme","social-links":"Footer_social-links__Ja99f"};